var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import { RECURRING_TABLE_LIST_QUESTION_ID, REDISPUTE_FIRST_QUESTION_ID } from '../../../../const/questionIds';
import i18n from '../../../../strings/i18n/i18n';
import { Body } from 'syf-component-library/ui/typography';
import { Trans } from 'react-i18next';
import LaunchPointName from '../../../../const/launchPointName';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import OnlineChatLink from '../../../../ui/atoms/OnlineChatLink';
import Subtitle from '../Subtitle';
var HelperText = function (_a) {
    var accountId = _a.accountId, disputeReason = _a.disputeReason, alertType = _a.alertType, helperText = _a.helperText, questionId = _a.questionId;
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var handleLaunchChat = function () {
        pointOfNeedChat(LaunchPointName.Disputes, accountId);
    };
    if (questionId === RECURRING_TABLE_LIST_QUESTION_ID) {
        return (_jsxs(_Fragment, { children: [_jsx(Body, { children: _jsx(Trans, { i18n: i18n, i18nKey: "questionnaire.recurringTransactionHelperText", components: [
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", "data-reason": "online chat", "data-type": "recurring transactions", "data-object": "button", onClick: handleLaunchChat }, "online chat")
                        ] }) }), _jsx(Stack, { size: "base" })] }));
    }
    if (helperText && alertType === 'Info') {
        return (_jsxs(_Fragment, { children: [_jsx(Subtitle, { helperText: helperText }), questionId === REDISPUTE_FIRST_QUESTION_ID && (_jsx(Body, __assign({ weight: "bold" }, { children: disputeReason }))), _jsx(Stack, { size: "xlarge" })] }));
    }
    return null;
};
export default HelperText;
//# sourceMappingURL=index.js.map